<div class="search-block">
<div class="container">
<div>
<div id="home_nav" class="row">
  <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
    <ol class="breadcrumb loginMenu ">
      <li class="breadcrumb-item" style="align-items: center;float:right;">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('home')">Home</a>
      </li>
      <li class="breadcrumb-item active">Help Article</li>
    </ol>
  </div>
  <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
    <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
      [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
      [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
      (keydown.enter)="onKeyEnterSearch($event,searchKey)" aria-label="Type here to Search an Article"
      placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
      No Suggestion...
    </ng-template>
    <span class="input-group-append" (click)="search(searchKey)">
      <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
        <i class="fa fa-search"></i>
      </button>
    </span>
  </div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
</div>
</div>
</div>
<div class="container">
<h2 class="help" >Help Article</h2>
</div>

<div class="container p-20">
<div class="row">
<div class="col-md-12 col-lg-12 col-xl-8">
<div class="BgColor article">
<div class="container p-0 article-bgrnd">
    <div class="section">
        <div class="row" *ngIf=this.parent>
          <span  style="padding: 12PX;">TOPICS :</span>
          <a class="bd-crumb-inactive" style="cursor: pointer;padding: 12PX;padding-left: 5px;"[routerLink]="['../search']" [queryParams]="{pk:this.pk,parentPk:this.parent}"> {{name}}</a>
        </div>
        <h1 [innerHtml]="articleTitle"></h1>
        <hr>
        <div class="sharebar clearfix">
            <span class="pull-right" style="color: black;" aria-hidden="true">PRINT <a  href="javascript:" (click)=printPage() title="Print"><i style="font-size:30px;padding: 10px;vertical-align: middle;cursor: pointer;" class="fa">&#xf02f;</i></a></span>
          </div>
          
        <p [innerHtml]="selectedValue"></p>
        <div class="date"><p>{{i18n['shp.last.updated']}} {{lastUpdated | date:"MM-dd-yyyy  h:mma"}} <br> {{i18n['shp.article.id']}} {{articleExternalId}}</p>
        </div>
        <mat-card class="mat-elevation-z0">
            <p class="improve" [innerHtml] = "i18n['article.feedback']" > </p>
            <mat-card-actions class="pad" *ngIf = "!isFeedbackSuccess">
                <button mat-button class="yes" (click)="getFeedback('YES')">{{i18n['shp.articles.yes']}}</button>
                <button mat-button class="no" (click)="getFeedback('NO')">{{i18n['shp.articles.no']}}</button>
            </mat-card-actions>
            <p class="improve" [innerHtml] = "i18n['shp.articles.thanksYou']" *ngIf = "isFeedbackSuccess"> </p>
        </mat-card>     

        <div class= "card-body" *ngIf="this.parent && innerWidth < 787" id="shp-articles-body">
          <div class="card-header" id="shp-articles-header">
            <strong>Related articles</strong>
          </div>
          <div class="card-body" id="shp-articles-content">
            <ul style="list-style-type: none;padding-left: 20px;" *ngFor="let kbView of kb">
              <a [routerLink]="['../article']" [queryParams]="{articleId: kbView.id,pk:this.pk,childPk:this.parent,article:articleTag}">
              <li class="line">
                  <h6 class="article-topic" [innerHTML]="kbView.name"></h6>
              </li>
            </a>
            </ul>
        </div>
      </div>     
    </div>
</div>
</div>
</div>
<div class="col-md-12 col-12 col-xs-12 col-lg-12 col-xl-4">
<div class="card-container" *ngIf="innerWidth > 787" id="shp-articles-body">
  <div class="card-header" *ngIf=this.parent  id="shp-articles-header">
    <strong>Related articles</strong>
  </div>
  <div class="card-body" id="shp-articles-content">
    <ul style="list-style-type: none;padding-left: 20px;" *ngFor="let kbView of kb">
      <a [routerLink]="['../article']" [queryParams]="{articleId: kbView.id,pk:this.pk,childPk:this.parent,article:articleTag}">
      <li class="line">
          <h6 class="article-topic" [innerHTML]="kbView.name"></h6>
      </li>
    </a>
    </ul>
</div>
<div id="popular-articles" class= "card-body" *ngIf="topArticles!=undefined">
  <div class="card-header" *ngIf="topArticles.total > 0 ">
      <strong>{{topArticleTitle}}</strong>
  </div>
  <div class="card-body">
  <ul style="list-style-type:none;padding-left: 20px;">
      <div *ngFor="let article of topArticles.items">
        <a class="top-articles-tooltip" [routerLink]="['../article']" [queryParams]="{articleId: article.article_id}">
          <li class="toparticles-block">
            {{article.article_title}}
          </li>
          <span class="top-articles-tooltip-text" style="pointer-events : none;">{{article.article_title}}</span>
        </a>
    </div>
  </ul>
</div>
</div>
</div>
</div>  
</div>
